<nz-tabset *ngIf="afterViewInit"
           (nzSelectedIndexChange)="closeAllDrawers()"
           [class.padding]="withPadding" [nzSelectedIndex]="activeTabIndex">
  @for (tab of tabs; track tab.name) {
    <nz-tab [nzTitle]="titleTemplate">
      <ng-template #titleTemplate>
        <app-st-icon style="margin-right: 5px" [name]="tab.icon"></app-st-icon>
        {{ tab.name }}
      </ng-template>

      <!-- Contenido de la pestaña -->
      <ng-container *ngTemplateOutlet="tab.tmpl"></ng-container>
    </nz-tab>
  }
</nz-tabset>

<ng-template #serviceTmpl>
  <app-layout-main
    [title]="'Macro Tareas'"
    [icon]="'checklist'"
    [mobileSearchClass]="mobileSearchClass"
    [color]="'#8E4EC6'"
    [bgColor]="'#F9F1FE'"
    [filters]="statusFilters"
    [primaryBtnLabel]="!!authService.loggedUser$.value?.createService ? 'Nueva Macro Tarea' : ''"
    [secondaryBtnLabel]="selectedServicesIds.size > 0 ? 'Eliminar' : ''"
    [showSecondaryBtn]="selectedServicesIds.size > 0 && !!authService.loggedUser$.value?.createService"
    [fullWidth]="true"
    [showGlobalSearchBar]="false"
    (filterEvent)="onStatusFilterSelect($event.code)"
    (primaryBtnEvent)="openCreateServiceDrawer()"
    (secondaryBtnEvent)="openBulkDeleteConfirmation()"
  >
    <div class="tab-content" [ngClass]="(isMobile$ | async) && showServiceFilters ? 'gap-200' : 'gap-100'">
      <div *ngIf="!!project.services?.length" class="flex-center-between" style="margin-bottom: 20px;">
        <div class="btns-mobile">
          <button (click)="toggleShowFilters()" class="text-btn-14" nz-button nzType="default" nzShape="round" nzSize="default">
            <app-st-icon class="prefix" [name]="'filter_alt'" [bold]="true"></app-st-icon>
            <span>Filtros</span>
          </button>
        </div>

        <!-- Filtros (Desktop) -->
      <!--   <ng-container *ngIf="!(isMobile$ | async)" [ngTemplateOutlet]="filtersTmpl"></ng-container> -->
      </div>

      <!-- Filtros (Mobile) -->
      <!-- <ng-container *ngIf="(isMobile$ | async)" [ngTemplateOutlet]="filtersTmpl"></ng-container> -->

      <div class="flex flex-column gap-100">
        @for (service of showServices; track service.id) {
          <app-info-card
            (click)="emitNavigateEvent(service.id)"
            [name]="service.name || 'Sin nombre'"
            [date]="service.startDatePlan"
            [icon]="gs.getServiceType(service.typeId || 0)?.icon || 'close'"
            [state]="$any(getServiceStateString(service))"
            [flowEvents]="service.flow?.events || defaultFlowEvents"
            [showStateBadge]="true"
            [totalOrders]="service.serviceOrders?.length"
            [completedOrders]="getCompletedOrdersCount(service)"
            [origin]="getLocation(service.originId)"
            [isActive]="selectedService?.id === service.id"
            [destination]="getLocation(service.destinationId)"
            [supplierId]="service.supplierId"
            [assignedTo]="getAssignedPartner(service)"
            [checkboxConfig]="{show: true, isChecked: selectedServicesIds.has(service.id)}"
            (checkboxEvent)="toggleSelectService(service.id)"
            [showServiceMenu]="!!authService.loggedUser$.value?.createService"
            (serviceMenuAction)="onServiceMenuAction($event, service)"
          ></app-info-card>
        } @empty {
          <app-empty-state [icon]="'checklist'" (btnPressEvent)="openCreateServiceDrawer()"
                           [hideBtn]="!authService.loggedUser$.value?.createService"
                          [object]="'tareas'" [btnIcon]="'upload'" [btnText]="'Añadir tareas'"></app-empty-state>
        }
      </div>
    </div>
  </app-layout-main>
</ng-template>

<ng-template #docTmpl>
  <div class="tab-content gap-200">
<!--    <h3 *ngIf="!(isMobile$ | async)" class="text-header-24">Documentos</h3>-->

    <app-doc-section
      [entityType]="'Project'"
      [entityId]="project.id"
      [documents]="project.documents || []"
      (isDocDrawerOpen)="sendIsDocDrawerOpen($event)"
    ></app-doc-section>
  </div>
</ng-template>

<ng-template #teamTmpl>
  <div class="tab-content">
    <h3 class="text-header-24">Equipo</h3>
  </div>
</ng-template>

<ng-template #inboxTmpl>
  <div class="tab-content">
    <h3 class="text-header-24">Inbox</h3>
  </div>
</ng-template>

<ng-template #filtersTmpl>
  <div [class.hidden]="(isMobile$ | async) && !showServiceFilters" class="filter-cont flex-center gap-150">
    @for (filter of servicesFilters; track filter) {
      <div class="st-badget" [ngClass]="filter.active ? 'black' : 'subtle-grey'" [nzDropdownMenu]="serviceTypeMenu"
           nz-dropdown [nzTrigger]="'click'">
        <app-st-icon *ngIf="filter.icon !== ''" [name]="filter.icon"></app-st-icon>
        <label>{{filter.name}}</label>
      </div>
      <nz-dropdown-menu #serviceTypeMenu="nzDropdownMenu">
        <ul nz-menu style="max-height: 500px; overflow: auto">
          @for (type of servOnlyOnProject; track type) {
            <li nz-menu-item [class.bg-grey-1]="type.id === serviceTypeFiltervalue"
                (click)="onFilterSelect(type.id)">
              {{ type.name }}
            </li>
          }
        </ul>
      </nz-dropdown-menu>
    }

    @for (filter of providersFilters; track filter) {
      <div class="st-badget" [ngClass]="filter.active ? 'black' : 'subtle-grey'"
           [nzDropdownMenu]="providerMenu" nz-dropdown [nzTrigger]="'click'">
        <app-st-icon *ngIf="filter.icon !== ''" [name]="filter.icon"></app-st-icon>
        <label>{{filter.name}}</label>
      </div>
      <nz-dropdown-menu #providerMenu="nzDropdownMenu">
        <ul nz-menu style="max-height: 500px; overflow: auto">
          @if (providersOnlyOnProject.length > 0) {
            <!-- Opción para limpiar filtro solo si hay proveedores -->
            <li nz-menu-item (click)="onProviderFilterSelect(null)">
              <strong>Limpiar filtro</strong>
            </li>
            <li nz-menu-divider></li>

            @for (provider of providersOnlyOnProject; track provider) {
              <li nz-menu-item [class.bg-grey-1]="provider.id === providerFilterValue"
                  (click)="onProviderFilterSelect(provider.id)">
                {{ provider.name }}{{ provider.surName }}
              </li>
            }
          } @else {
            <li nz-menu-item disabled>No hay proveedores disponibles en este proyecto</li>
          }
        </ul>
      </nz-dropdown-menu>
    }
  </div>
</ng-template>

<ng-template #containersTmpl>
  <div class="tab-content gap-200">
<!--    <h3 class="text-header-24">Contenedores</h3>-->
    <app-container-section></app-container-section>
  </div>
</ng-template>

<app-confirmation-modal #confirmationModal (confirmed)="onDeleteConfirmed($event)"></app-confirmation-modal>


